import { useNavigate } from "react-router-dom";
import { useToast } from "@/shared/providers/ToastProvider";

export function useFormSuccess() {
  const navigate = useNavigate();
  const { showToast } = useToast();

  return (href: string, message: string) => {
    showToast(message);
    navigate(href);
  };
}
